import { Card } from '@/components/ui/card';

interface ErrorStateProps {
  error: unknown;
}

export function ErrorState({ error }: ErrorStateProps) {
  const message = error instanceof Error ? error.message : 'This form could not be loaded.';
  return (
    <div className="form-shell flex items-center justify-center">
      <Card className="form-paper max-w-md p-6 text-center">
        <h1 className="mb-2 text-2xl font-semibold text-destructive">Form Not Found</h1>
        <p className="text-sm text-muted-foreground">{message}</p>
      </Card>
    </div>
  );
}
